<form [formGroup]="form" (submit)="submitForm()">
  <div class="row">
    <mat-form-field>
      <mat-label>Search query</mat-label>
      <mat-icon matSuffix>search</mat-icon>
      <input matInput formControlName="query" />
    </mat-form-field>
  </div>
  <div class="row actions">
    <button mat-raised-button class="submit-button" color="primary" [disabled]="loading">
      Search
      <mat-icon *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
      </mat-icon>
    </button>
  </div>
</form>